<div class="jobseeker-work">
  <div *ngIf="isEditModeOn"></div>
  <div *ngIf="!isEditModeOn">
    <table>
      <tr>
        <td style="text-align: center; padding-right: 5px; min-width: 20px">
          <!--<span ng-if="pendingJobseekerWorkExperiencesMap[item.jobseekerWorkExperienceId]!=null" class="fa fa-exclamation-circle in-moderation" title="@Resources.Message.IsInModeration"></span>-->
          <!--<span ng-if="pendingJobseekerWorkExperiencesMap[item.jobseekerWorkExperienceId]==null">&nbsp;</span>-->
          <span>&nbsp;</span>
        </td>
        <td style="text-align: left; min-width: 64px">
          <button
            class="fa fa-times-circle btn btn-link"
            (click)="onDeleteWorkExperienceClick()"
            [disabled]="isEditModeOn"
          ></button>
          <button
            class="fa fa-pencil btn btn-link"
            (click)="onEditWorkExperienceClick()"
            *ngIf="workExperience?.jobseekerWorkExperienceId > 0"
            [disabled]="isEditModeOn"
          ></button>
        </td>
        <td width="80%" colspan="2">
          <span
            >{{ item?.dateFromYear }}
            {{ monthListShortMap[item?.dateFromMonth] }} -
          </span>
          <span *ngIf="!item.isCurrent"
            >{{ item?.dateToYear }}
            {{ monthListShortMap[item?.dateToMonth] }}</span
          >
          <span *ngIf="item.isCurrent">{{ 'label.Present' | translate }}</span>
          <!--<span> &nbsp; &nbsp; | &nbsp; &nbsp; {{(pendingJobseekerWorkExperiencesMap[item?.jobseekerWorkExperienceId] || item).positionTitle}} </span>-->
          <span> &nbsp; &nbsp; | &nbsp; &nbsp; {{ item?.positionTitle }} </span>
          <!--<span class="employer"> &nbsp; &nbsp; | &nbsp; &nbsp; {{(pendingJobseekerWorkExperiencesMap[item.jobseekerWorkExperienceId] || item).employer}}</span>-->
          <span class="employer">
            &nbsp; &nbsp; | &nbsp; &nbsp; {{ item?.employer }}</span
          >

          <br />
          <div
            *ngFor="let group of workExperienceHeadCategories"
            class="categories"
          >
            <span style="font-weight: bold"
              >{{ group?.headCategory?.name }}: &nbsp; &nbsp;</span
            >
            <span
              *ngFor="
                let category of group.childCategories;
                let lastItem = last
              "
            >
              {{ category?.category?.name }}
              <span *ngIf="!lastItem">, &nbsp;</span>
            </span>
            <span>&nbsp; &nbsp; &nbsp;</span>
          </div>
        </td>
        <td style="text-align: right; width: 100%">
          <form
            id="{{ 'watchmt_' + item?.jobseekerWorkExperienceId }}"
            action="{{ getDownloadUrl() }}"
            method="post"
            target="_blank"
          >
            <span *ngIf="item?.attachment != null">
              <!--<span ng-if="(pendingJobseekerWorkExperiencesMap[item.jobseekerWorkExperienceId] || item).attachment!=null">-->

              <a
                target="_blank"
                href="javascript:void(0)"
                (click)="
                  onDownloadWorkExperienceAttachmentClick(
                    'watchmt_' + item?.jobseekerWorkExperienceId
                  )
                "
                ><i class="fa fa-paperclip icon"></i>&nbsp;{{
                  'label.Attachment' | translate
                }}</a
              >
            </span>
            <input
              type="hidden"
              name="jobseekerId"
              value="{{ item?.jobseekerId }}"
            />
            <input
              type="hidden"
              name="jobseekerWorkExperienceId"
              value="{{ item?.jobseekerWorkExperienceId }}"
            />
            <!--<input type="hidden" name="isPending" value="{{pendingJobseekerWorkExperiencesMap[item.jobseekerWorkExperienceId] != null}}"/> -->
            <input
              type="hidden"
              name="isNew"
              value="{{ item?.jobseekerWorkExperienceId < 0 }}"
            />

            <!--<input type="hidden" name="jobseekerWorkExperienceId" value="{{item.jobseekerWorkExperienceId}}" />
                        <input type="hidden" name="isPending" value="{{pendingJobseekerWorkExperiencesMap[item.jobseekerWorkExperienceId] != null}}"
                        />
                        <input type="hidden" name="isNew" value="{{item.jobseekerWorkExperienceId<0}}" />-->
          </form>
        </td>
        <td width="10%"></td>
      </tr>
      <tr>
        <td colspan="5">&nbsp;</td>
      </tr>
      <tr>
        <td></td>
        <td></td>
        <td>
          <div
            [innerHtml]="
              item?.description != null ? item.description + '&nbsp;' : '&nbsp;'
            "
          ></div>
          <!--<div ng-bind-html="(pendingJobseekerWorkExperiencesMap[item.jobseekerWorkExperienceId] || item).description"></div>-->
        </td>
      </tr>
    </table>
  </div>
  <hr-work-experience-editor
    *ngIf="isEditModeOn"
    [workExperience]="workExperience"
    (onUpdate)="onWorkExperienceEdited($event)"
    (onCancelEdit)="onCancelEditWorkExperience()"
  ></hr-work-experience-editor>

  <iframe
    name="hiddenFrame"
    style="position: absolute; top: -1px; left: -1px; width: 1px; height: 1px"
  ></iframe>
</div>
